// extracted by mini-css-extract-plugin
export default {"lettersTexto":"lettershine_lettersTexto__nwiDd","show":"lettershine_show__phCuq"};